import script from "./ChatPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPanel.vue?vue&type=script&setup=true&lang=js"

import "./ChatPanel.vue?vue&type=style&index=0&id=7399fac6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7399fac6"]])

export default __exports__